// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__J5_7D","options":"AnswerScale_options__2JLGU","selected":"AnswerScale_selected__2MYfs"};